import { capitalise, replaceDashWithSpace } from '@uc/utilities';
import { ProductEnum } from '@uc/shared/data-models';
import { ATHE } from '../static/clearing-course-search.properties';
import { NonClearingFilters } from '../models/clearing-course-search.models';
import { getRouteSegmentsAndQueryParams } from './route.utils';

export const formatClearingTitle = (copy: string, subject: string, year: number) => {
	const formattedSubject = capitalise(replaceDashWithSpace(subject));

	const formattedCopy = copy
		.replace(/\[SUBJECT\]/g, formattedSubject)
		.replace(/\[YEAR\]/g, year.toString());

	return formattedCopy;
};

export const formatClearingDisabledDesc = (copy: string, subject: string, date = '') => {
	const formattedSubject = capitalise(replaceDashWithSpace(subject));

	const formattedCopy = copy
		.replace(/\[SUBJECT\]/g, formattedSubject)
		.replace(/\[DATE\]/g, date);

	return formattedCopy;
};

export const formatClearingEnabledDesc = (
	copy: string,
	subject: string,
	courseCount = 0,
	uniCount = 0,
) => {
	const formattedSubject = capitalise(replaceDashWithSpace(subject));
	const verifiedCourseCount = courseCount > 0 ? courseCount : '';
	const verifiedUniCount = uniCount > 0 ? uniCount : '';

	const formattedCopy = copy
		.replace(/\[SUBJECT\]/g, formattedSubject)
		.replace(/\[COURSE_COUNT\]/g, verifiedCourseCount.toString())
		.replace(/\[UNI_COUNT\]/g, verifiedUniCount.toString())
		.replace(/\s{2}/g, ' '); // removed extra space if uni / course count is 0

	return formattedCopy;
};

export const isPartTimeCourse = (mode: string) => mode === 'part-time';

export const isValidClearingDegreeQueryParam = (degree = '') => {
	const invalidClearingDegrees = [
		ProductEnum.Undergraduate,
		ProductEnum.Postgraduate,
		ProductEnum.Clearing,
		ATHE,
	];
	return !invalidClearingDegrees.includes(degree);
};

export const removeClearingFilters = (url: string, degree?: string | undefined) => {
	const removedFilters: NonClearingFilters[] = [];

	// check if part-time course
	const { queryParams } = getRouteSegmentsAndQueryParams(url);
	isPartTimeCourse(queryParams['mode']) && removedFilters.push('mode');

	// check if access to higher education
	degree === ATHE && removedFilters.push('degree');

	return removedFilters;
};
